export default class MainPageFifthScreenCommon {
    public static readonly selectors = {
        screen: ".js-main-page-effect-section",
        screenContainer: ".js-main-page-effect-section-container",
        topContent: ".js-main-page-effect-section-top-content",
        bottomContent: ".js-main-page-effect-section-bottom-content",
        bottomContentCards: ".js-main-page-effect-section-bottom-content-cards-list",
        bottomContentLinks: ".js-main-page-effect-section-bottom-content-links",
        innerCenterPointMobile: ".js-main-page-effect-section-center-content-mobile",
        circleCenterPoint: ".js-main-page-effect-section-center-content",
        cards: ".js-main-page-effect-card",
    };
}
